import { render, staticRenderFns } from "./View.vue?vue&type=template&id=9cd74c3a&"
import script from "./View.vue?vue&type=script&lang=ts&"
export * from "./View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports